export default "__VITE_ASSET__CNNzaFxk__"